/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * console.log(Shopify.locale)
 */

const config = { childList: true, subtree: true, characterData: true, attributes: true };
let paymentButton;

const buttonTranslations = {
    'sl-SI': 'Kupite zdaj',
    'hr': 'Kupi odmah',
    'sk': 'Kúpiť teraz',
    'cs': 'Koupit nyní',
    'default': 'Buy now'
};

const callback = function(mutationsList, observer) {
    for(let mutation of mutationsList) {
        if (mutation.type === 'childList' || mutation.type === 'subtree') {
            if (!paymentButton) {
                paymentButton = document.querySelector('[data-testid="Checkout-button"]');
            }
        }

        if (paymentButton && (mutation.type === 'characterData' || mutation.type === 'attributes')) {
            const locale = Shopify.locale || 'default';
            const buttonText = buttonTranslations[locale];

            if (paymentButton.textContent !== buttonText) {
                paymentButton.textContent = buttonText;
                observer.disconnect();
            }
        }
    }
};

const observer = new MutationObserver(callback);
observer.observe(document, config);

document.addEventListener('bundler:bundle_widget_created', function(e) {
    // Replace text in bundler description
    var descriptionElement = document.querySelector('.bndlr-bundle-description');
    if (descriptionElement) {
        descriptionElement.innerText = window.bundler_description_text;
    }
    // Replace text in add to cart button
    var addToCartButtonElement = document.querySelector('.bndlr-add-to-cart');
    if (addToCartButtonElement) {
        addToCartButtonElement.innerText = window.call_to_action_text;
    }
    // Replace text price summary
    // var priceSummaryElement = document.querySelector('.bndlr-total-price');
    // if (priceSummaryElement) {
    //     var translatedPriceSummaryElement = document.createElement('div');
    //     translatedPriceSummaryElement.className = "bndlr-total-price-translation";
    //     translatedPriceSummaryElement.innerText = window.price_summary_text;
    //     priceSummaryElement.parentNode.insertBefore(translatedPriceSummaryElement, priceSummaryElement);
    // }
    // Replace text under button
    var underButtonWarningElement = document.querySelector('.bndlr-bundle-checkout-warning');
    if (underButtonWarningElement) {
        underButtonWarningElement.innerText = window.under_button_text;
    }
    // Replace text volume title
    var priceSummaryElements = document.querySelectorAll('.bndlr-total-price');
    priceSummaryElements.forEach(function(element) {
        if (!element.previousElementSibling || element.previousElementSibling.className !== "bndlr-total-price-translation") {
            var translatedPriceSummaryElement = document.createElement('div');
            translatedPriceSummaryElement.className = "bndlr-total-price-translation";
            translatedPriceSummaryElement.innerText = window.price_summary_text;
            element.parentNode.insertBefore(translatedPriceSummaryElement, element);
        }
    });
    // Replace text volume main text
    var volumeMainTextElements = document.querySelectorAll('.bndlr-volume-main-text');
    volumeMainTextElements.forEach(function(element) {
        var quantity = element.innerText.match(/\d+/)[0];
        var translatedText = window.volume_main_text.replace('{quantity}', quantity);
        element.innerText = translatedText;
    }); 
    // Replace text volume saving text
    var volumeSavingTextElements = document.querySelectorAll('.bndlr-volume-saving-text');
    volumeSavingTextElements.forEach(function(element) {
        if (!element.dataset.translated) {
            element.innerText = window.volume_saving_text + ' ' + element.innerText;
            element.dataset.translated = true;
        }
    });

    // Check if Shopify.locale is "sk"
    if (Shopify.locale === "sk") {
      var productDivs = document.querySelectorAll('.bndlr-product');
      
      productDivs.forEach(function(div) {
          var productId = div.getAttribute('data-product-id');
          var productData = allProductDetails[productId];
  
          if (productData) {
              // Update product name
              var titleDiv = div.querySelector('.bndlr-product-qn-container .bndlr-product-title');
              if (titleDiv) {
                  titleDiv.innerText = productData.productName;
              }
  
              // Update variants
              var selectElement = div.querySelector('.bndlr-select-variant');
              if (selectElement) {
                  selectElement.querySelectorAll('option').forEach(function(option) {
                      var variantId = option.value;
                      var variantName = productData.variants[variantId];
                      if (variantName) {
                          option.innerText = variantName;
                      }
                  });
              }
          }
      });
    }
});

function addToCart() {
  var formOBJ = {
    quantity: 1,
    id: 42145879818494
  };

  fetch("/cart/add.js", {
    method: "POST",
    cache: "no-cache",
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formOBJ)
  })
    .then((response) => {
      console.log("success!");
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
    });
}

document.addEventListener("DOMContentLoaded", function() {
  var locale = Shopify.locale || 'default';

  var urlMap = {
    'https://www.topa.si/pages/dassy-velikosti': {
      'sl-SI': 'https://www.topa.si/pages/dassy-velikosti',
      'hr': 'https://www.topa.hr/pages/dassy-velikosti',
      'sk': 'https://www.safe-beaver.sk/pages/velkosti-dassy',
      'default': 'https://www.topa.si/pages/dassy-velikosti'
    },
    'https://www.topa.si/pages/dassy-delovna-oblacila-navodila-za-pranje': {
      'sl-SI': 'https://www.topa.si/pages/dassy-delovna-oblacila-navodila-za-pranje',
      'hr': 'https://www.topa.hr/pages/dassy-delovna-oblacila-navodila-za-pranje',
      'sk': 'https://www.safe-beaver.sk/pages/dassy-pracovne-oblecenie-instrukcie-na-pranie',
      'default': 'https://www.topa.si/pages/dassy-delovna-oblacila-navodila-za-pranje'
    },
    'https://www.topa.si/pages/delovna-oblacila-tekstil': {
      'sl-SI': 'https://www.topa.si/pages/delovna-oblacila-tekstil',
      'hr': 'https://www.topa.hr/pages/delovna-oblacila-tekstil',
      'sk': 'https://www.safe-beaver.sk/pages/pracovne-oblecenie-textil',
      'default': 'https://www.topa.si/pages/delovna-oblacila-tekstil'  
    },
    'https://www.topa.si/pages/en-14404-2004-a1-2010': {
      'sl-SI': 'https://www.topa.si/pages/en-14404-2004-a1-2010',
      'hr': 'https://www.topa.hr/pages/en-14404-2004-a1-2010',
      'sk': 'https://www.safe-beaver.sk/pages/en-14404-2004-a1-2010',
      'default': 'https://www.topa.si/pages/en-14404-2004-a1-2010'  
    },
    'https://www.topa.si/pages/delovna-oblacila-dassy-simboli': {
      'sl-SI': 'https://www.topa.si/pages/delovna-oblacila-dassy-simboli',
      'hr': 'https://www.topa.hr/pages/delovna-oblacila-dassy-simboli',
      'sk': 'https://www.safe-beaver.sk/pages/pracovne-oblecenie-dassy-symboly',
      'default': 'https://www.topa.si/pages/delovna-oblacila-dassy-simboli'  
    },
    'https://www.topa.si/pages/delovna-oblacila-dassy-notranja-dolzina-nog': {
      'sl-SI': 'https://www.topa.si/pages/delovna-oblacila-dassy-simboli',
      'hr': 'https://www.topa.hr/pages/delovna-oblacila-dassy-notranja-dolzina-nog',
      'sk': 'https://www.safe-beaver.sk/pages/pracovne-oblecenie-dassy-symboly',
      'default': 'https://www.topa.si/pages/delovna-oblacila-dassy-notranja-dolzina-nog'  
    }
    // Add more URLs as needed
  };

  Object.keys(urlMap).forEach(function(originalUrl) {
    var links = document.querySelectorAll('a[href="' + originalUrl + '"]');
    links.forEach(function(link) {
      link.href = urlMap[originalUrl][locale];
    });
  });

  var linkItems = document.querySelectorAll('.footer__link-item.link');
  
  if (locale !== 'sl-SI') {
    linkItems.forEach(function(linkItem) {
      if (linkItem.textContent.trim() === 'Blog') {
        linkItem.style.display = 'none';
      }
    });
  }
});

function checkZoomAndScreenSize() {
    const zoomLevel = window.devicePixelRatio;
    const miniCart = document.getElementById('mini-cart');

    if (zoomLevel > 1.4) {
        miniCart.classList.add('zoomed-in');
    } else {
        miniCart.classList.remove('zoomed-in');
    }
}

// document.addEventListener('DOMContentLoaded', checkZoomAndScreenSize);
// window.addEventListener('resize', checkZoomAndScreenSize);

// window.addEventListener('load', function() {
//   var hash = window.location.hash;
//   if (hash === '#shopify-app-section') {
//     var targetElement = document.querySelector('.jdgm-rev-widg__header');
//     if (targetElement) {
//       setTimeout(function() {
//         targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
//       }, 500);
//     }
//   }
// });

// document.addEventListener('DOMContentLoaded', function() {
//   // Get the elements
//   var modal = document.querySelector('.custom-modal');
//   var modalLink = document.querySelector('.custom-modal-link');
//   var closeModal = document.querySelector('.custom-modal-close');
//   var modalDialog = document.querySelector('.custom-modal-dialog'); // Get the modal dialog
// 
//   // Add click event listener to the custom modal link
//   modalLink.addEventListener('click', function() {
//     modal.style.display = 'flex';
//   });
// 
//   // Add click event listener to the custom modal close button
// //   closeModal.addEventListener('click', function(event) {
//     event.stopPropagation();
//     modal.style.display = 'none';
//   });
// 
//   // Modify this event listener to close the modal only if the click is outside the dialog
//   modal.addEventListener('click', function(event) {
//     if (event.target === modal) {
//       modal.style.display = 'none';
//     }
//   });
// 
//   // Prevent clicks inside the modal dialog from closing it
//   modalDialog.addEventListener('click', function(event) {
//     event.stopPropagation(); //
//   });
// });
